import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BannerData } from '@fcp/lib-ui';
import { BannerContainerService } from './banner-container.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'fcp-banner-container',
  template: `
    <fcp-banner
      [banner]="banner | async"
      (wasClicked)="wasClicked.emit($event)"
      (wasClickedScrollToElement)="wasClickedScrollToElement.emit($event)"
    ></fcp-banner>
  `
})
export class BannerContainerComponent implements OnInit {
  @Input() public id: string;
  @Output() public wasClicked: EventEmitter<any> = new EventEmitter();
  @Output() public wasClickedScrollToElement: EventEmitter<
    any
  > = new EventEmitter();

  public banner: Observable<BannerData>;

  constructor(private bannerService: BannerContainerService) {}

  ngOnInit() {
    this.banner = this.bannerService.getBanner(this.id);
  }
}
